import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Home from './pages/Home';
import ResetPassword from './pages/ResetPassword';
import { requestNotificationPermission } from './firebase';

const API = 'https://sendvigo-backend-production.up.railway.app';

function AppContent() {
  const { isLoggedIn, login, token, suspendMessage, clearSuspendMessage } = useAuth();
  const [screen, setScreen] = useState('landing');
  const [resetToken, setResetToken] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const googleToken = params.get('token');
    const name = params.get('name');
    const id = params.get('id');

    if (googleToken && name && id) {
      login(googleToken, { id: parseInt(id), name: decodeURIComponent(name) });
      window.history.replaceState({}, '', window.location.pathname);
    } else if (googleToken) {
      setResetToken(googleToken);
      setScreen('reset-password');
    }
  }, []);

  useEffect(() => {
  if (isLoggedIn && token) {
    console.log('Pidiendo permisos de notificación...');
    requestNotificationPermission().then(fcmToken => {
      console.log('FCM Token:', fcmToken);
      if (fcmToken) {
        fetch(`${API}/users/me/fcm-token`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
          body: JSON.stringify({ fcmToken })
        });
      }
    });
  }
}, [isLoggedIn, token]);

  // Si la sesión se cerró automáticamente por suspensión, en cuanto volvemos
  // a la pantalla de login le enseñamos ese mensaje en vez del formulario de
  // "landing" — así queda claro por qué se cerró, sea cual fuera la pantalla
  // en la que estuviera el usuario.
  useEffect(() => {
    if (suspendMessage) setScreen('login');
  }, [suspendMessage]);

  const avisoSuspension = suspendMessage && (
    <div style={{
      backgroundColor: '#f8717115', border: '1px solid #f8717130', color: '#f87171',
      borderRadius: '14px', padding: '14px 16px', margin: '16px', fontSize: '13px',
      lineHeight: '1.5', position: 'relative',
    }}>
      <button onClick={clearSuspendMessage}
        style={{position: 'absolute', top: '10px', right: '12px', background: 'none',
          border: 'none', color: '#f87171', cursor: 'pointer', fontSize: '14px'}}>
        ✕
      </button>
      {suspendMessage}
    </div>
  );

  if (isLoggedIn) return <Home />;
  if (screen === 'reset-password') return <ResetPassword token={resetToken} onDone={() => setScreen('login')} />;
  if (screen === 'login') return (
    <>
      {avisoSuspension}
      <Login onBack={() => setScreen('landing')} onRegister={() => setScreen('register')} />
    </>
  );
  if (screen === 'register') return <Register onBack={() => setScreen('landing')} />;
  return (
    <>
      {avisoSuspension}
      <Landing onLogin={() => setScreen('login')} onRegister={() => setScreen('register')} />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}